export const LINK = {
  linkForgot: "/auth/forgot-password",
  linkVerify: "/auth/verify",
  linkReset: "/auth/reset-password",
};
